/**
 * Subir tickets de un inmueble: lo que comparten la tarjeta de cada inmueble en Ingresos y
 * gastos, la tarjeta «Varios pisos» y la pantalla de Suministros de cada piso.
 *
 * NO SE ELIGE EL MES. Cada ticket se apunta en el mes de la fecha que se lee en él (o, si no se
 * lee ninguna, en el de hoy). Quien suelta la factura de la luz de septiembre el 4 de octubre no
 * tiene que acordarse de cambiar antes a septiembre. El panel de la cola dice en qué mes ha
 * quedado cada uno, para que nadie lo busque donde no está.
 *
 * VAN A LA COLA (`UploadQueue.tsx`): se sueltan varios a la vez, se puede seguir soltando
 * mientras se suben, y se suben de uno en uno.
 *
 * SIN PISO (`property: null`), el piso lo dice el nombre del fichero o la propia factura; si
 * nada lo dice, la cola lo pregunta entre `pisos`.
 */
import { useUploadQueue } from './UploadQueue';

export { LEDGER_ACCEPT } from './UploadQueue';

export function useLedgerUpload(
  property: { id: string; name: string } | null,
  pisos?: { id: string; name: string }[],
) {
  const cola = useUploadQueue();
  return {
    subir: (files: File[]) =>
      cola.encolar(files, {
        propertyId: property?.id ?? null,
        origen: property?.name ?? 'Varios pisos',
        ...(pisos ? { pisos } : {}),
      }),
    /** Cuántos de este piso quedan por subir. */
    enCola: cola.pendientes(property?.id ?? null),
  };
}
